import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-12" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold form-label mb-2" }, "Government", -1)
const _hoisted_9 = { class: "col-6" }
const _hoisted_10 = ["label"]
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "row mb-8" }
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_15 = {
  key: 0,
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_16 = { class: "indicator-label" }
const _hoisted_17 = { class: "indicator-progress" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('read', 'assets'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('updateArea')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitUpdate
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _withDirectives(_createElementVNode("select", {
                      class: "form-select form-select-sm form-select-solid",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItems.govId) = $event))
                    }, [
                      _createElementVNode("option", {
                        selected: "",
                        disabled: "",
                        label: _ctx.translate('selectGovernment'),
                        value: ""
                      }, null, 8, _hoisted_10),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.govs, (gov) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: gov.id,
                          value: gov.id
                        }, _toDisplayString(gov.titleAr), 9, _hoisted_11))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.selectedItems.govId]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_Multiselect, {
                      modelValue: _ctx.selectedItems.areaIds,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedItems.areaIds) = $event)),
                      required: true,
                      mode: "tags",
                      label: "titleAr",
                      trackBy: "titleAr",
                      searchable: true,
                      multiple: true,
                      options: _ctx.areas,
                      placeholder: _ctx.translate('selectAreas'),
                      valueProp: "id",
                      noResultsText: _ctx.translate('noResultsFound')
                    }, null, 8, ["modelValue", "options", "placeholder", "noResultsText"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                (_ctx.can('update', 'assets'))
                  ? (_openBlock(), _createElementBlock("button", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.translate('saveChanges')), 1),
                      _createElementVNode("span", _hoisted_17, [
                        _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                        _hoisted_18
                      ])
                    ], 512))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit"])
        ])
      ]))
    : _createCommentVNode("", true)
}